import env from './env';

const util = {
    isEmptyObject(obj) {
        if (typeof obj !== 'object') {
            return false;
        }

        return Object.keys(obj).length === 0;
    },

    // 将对象转换成 url参数 ： a=xxx&b=xxx 这样的字符串
    paramToStr(params = {}) {
        let paramArray = [];
        let keys = Object.keys(params);

        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (params[key] !== undefined) {
                paramArray.push(`${key}=${params[key]}`);
            }
        }
        return paramArray.join('&');
    },

    // 从 location.search 中获取 query 参数
    getQuery(search) {
        var queryObj = new Object();
        if (search.indexOf('?') != -1) {
            var params = search.substr(1);
            params = params.split('&');
            for (var i = 0; i < params.length; i++) {
                let query = params[i].split('=');
                queryObj[query[0]] = query[1];
            }
        }
        return queryObj;
    },

    /**
     * 获取 从 min 到 max 的随机数 ，
     * @param {*} min
     * @param {*} max
     */
    random(min, max) {
        if (max == null) {
            max = min;
            min = 0;
        }
        return min + Math.floor(Math.random() * (max - min + 1));
    },

    /**
     *  比较版本大小
     *
     * @param {*} v1 版本1
     * @param {*} v2
     * @returns
     */
    versionCompare(v1, v2) {
        //去掉收尾空格
        v1 = v1.replace(/(^\s+)|(\s+$)/gi, '');
        v2 = v2.replace(/(^\s+)|(\s+$)/gi, '');

        //空检查
        if (!v1 || !v2) {
            return;
        }
        //截取v1,v2中的版本数字
        v1 = /\d(\.|\d)*\d/gi.exec(v1)[0];
        v2 = /\d(\.|\d)*\d/gi.exec(v2)[0];
        //版本比较，我们分为三个数组然后比较
        var arr1 = v1.split('.');
        arr1 = arr1.map(function(item) {
            return parseInt(item);
        });
        var arr2 = v2.split('.');
        arr2 = arr2.map(function(item) {
            return parseInt(item);
        });
        if (arr1[0] > arr2[0]) {
            return true;
        } else if (arr1[0] == arr2[0]) {
            if (arr1[1] > arr2[1]) {
                return true;
            } else if (arr1[1] == arr2[1]) {
                if (arr1[2] >= arr2[2]) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return false;
    },

    getPageScrollTop() {
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        return scrollTop;
    },

    /**
     * Parse the time to string
     * @param {(Object|string|number)} time
     * @param {string} cFormat
     * @returns {string | null}
     */
    parseTime(time, cFormat) {
        if (!time) return '';
        if (arguments.length === 0) {
            return null;
        }
        const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
        let date;
        if (typeof time === 'object') {
            date = time;
        } else {
            if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
                time = parseInt(time);
            }
            // 将2019-01-01 替换为2019/01/01, 前者在ios上无法解析
            if (typeof time === 'string' && /^([0-9]+-)+/.test(time)) {
                time = time.replace(/-/g, '/');
            }
            if (typeof time === 'number' && time.toString().length === 10) {
                time = time * 1000;
            }
            date = new Date(time);
        }
        const formatObj = {
            y: date.getFullYear(),
            m: date.getMonth() + 1,
            d: date.getDate(),
            h: date.getHours(),
            i: date.getMinutes(),
            s: date.getSeconds(),
            a: date.getDay(),
        };
        const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
            const value = formatObj[key];
            // Note: getDay() returns 0 on Sunday
            if (key === 'a') {
                return ['日', '一', '二', '三', '四', '五', '六'][value];
            }
            return value.toString().padStart(2, '0');
        });
        return timeStr;
    },

    /**
     * @param timestamp 时间戳
     * @param fmt
     * @returns {*}
     * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
     * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
     * 例子：
     * (new Date()).Format(1540396800000,"yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
     * (new Date()).Format(1540396800000,"yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
     */
    getFormatDate(timestamp, fmt) {
        if (!timestamp) return;

        let date = new Date(timestamp);

        let o = {
            'M+': date.getMonth() + 1, //月份
            'd+': date.getDate(), //日
            'h+': date.getHours(), //小时
            'm+': date.getMinutes(), //分
            's+': date.getSeconds(), //秒
            'q+': Math.floor((date.getMonth() + 3) / 3), //季度
            S: date.getMilliseconds(), //毫秒
        };

        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }

        for (let k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
            }
        }

        return fmt;
    },

    // 获取元素的scrollTop
    getScrollTop(element) {
        if (element === window) {
            return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop);
        }
        return element.scrollTop;
    },

    //设置scrollTop
    setScrollTop(element, scrollTop) {
        'scrollTop' in element ? (element.scrollTop = scrollTop) : element.scrollTo(element.scrollX, scrollTop);
    },

    /**
     * 检测字符串是否是淘口令
     * @param {*} searchString
     */
    checkIsTaoBaoCommand(searchString) {
        const fingerLeftPointCode = 128072; // 👈 这个符号的unicode
        const fingerRightPointCode = 128073; // 👉 这个符号的unicode
        const existL = searchString.indexOf(String.fromCodePoint(fingerLeftPointCode)) > -1;
        const existR = searchString.indexOf(String.fromCodePoint(fingerRightPointCode)) > -1;
        // 判断是否有那两个emoji
        const existEmoji = existL && existR;
        // 判断是否满足淘口令字符
        const reg = /描述.*[0-9a-zA-Z]{6,}.*后到/;
        const matchTAO = reg.test(searchString);

        return existEmoji || matchTAO;
    },

    checkIsUrl(str = '') {
        let reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+/;
        return reg.test(str);
    },

    /**
     * 获取剩余时间 , 以下时间都是时间戳 13位的 ms
     * @param  {Number} endTime    截止时间
     * @param  {Number} deviceTime 设备时间
     * @param  {Number} serverTime 服务端时间
     * @return {Object}            剩余时间对象
     */
    getRemainTime(endTime, deviceTime, serverTime) {
        const time = endTime - Date.parse(new Date()) + (deviceTime - serverTime); // 一开始服务端的时间和客户端的时间差异
        return time;
    },

    /**
     * 获取剩余时间 , 以下时间都是时间戳 13位的 ms
     * @param  {Number} endTime    截止时间
     * @param  {Number} timeDiff   设备与服务器的差
     * @return {Object}            剩余时间对象
     */
    getRemainTimePlus(endTime, timeDiff) {
        const time = endTime - (Date.parse(new Date()) + timeDiff); // 一开始服务端的时间和客户端的时间差异
        return time;
    },

    /**
     * 格式化时间
     */
    formatTime(time) {
        const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / 1000 / 60) % 60);
        const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        const days = Math.floor(time / (1000 * 60 * 60 * 24));
        return { days, hours, minutes, seconds };
    },

    /**
     * 格式化时间 保留48小时
     */
    formatTimeFor48(time) {
        const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / 1000 / 60) % 60);
        let days = Math.floor(time / (1000 * 60 * 60 * 24));
        let hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        hours = days == 1 ? hours + 24 : hours;
        days = days == 1 ? 0 : days;

        return { days, hours, minutes, seconds };
    },

    /**
     * 格式化时间
     */
    formatTimeWithoutDays(time) {
        const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / 1000 / 60) % 60);
        const hours = Math.floor(time / (1000 * 60 * 60));
        return { hours, minutes, seconds };
    },

    patchPosition(num) {
        if (num >= 10) {
            return num;
        } else {
            return '0' + num;
        }
    },

    // 将设计稿的px 转为 实际的像素
    designPxToPx(value) {
        let screenWidth = document.documentElement.getBoundingClientRect().width;
        let scale = screenWidth / 750;
        return value * scale;
    },
    // 判断是否 dom
    isDomObject(obj) {
        let type = typeof HTMLElement === 'object';
        if (type) {
            return obj instanceof HTMLElement;
        } else {
            return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
        }
    },
    /**
     * link 链接
     * this 当前的vue实例
     * 针对特殊字符进行链接跳转商城首页指定tab（为兼容app跳转做特殊处理）
     */
    handleShopLink(link, vm) {
        if (link.indexOf('appTab=shop&&shopTab=') > -1) {
            const fid = link.split('shopTab=')[1].split('?')[0];
            if (vm.$env.isApp) {
                const cacheKey = 'targetFenceId';
                window.localStorage.setItem(cacheKey, fid);
                window.ZZCFL.Utils.nativeTabSwitch('shop');
            } else {
                vm.$router.push({
                    path: '/shop',
                    query: {
                        fId: fid,
                    },
                });
            }
            return true;
        } else {
            return false;
        }
    },
    /**
     * await方式调用的定时函数，将会在超时后返回
     * @param {number} timeout
     */
    wait(timeout) {
        return new Promise(res => setTimeout(res, timeout));
    },
    /**
     *
     * 返回用户唯一id;
     *
     */
    getUniqueHash() {
        const isIos = env.isIos;
        const deviceUniqueHash = window.localStorage.getItem('deviceUniqueHash');
        if (deviceUniqueHash) return deviceUniqueHash;

        const StorageStr = window.localStorage.getItem('IDINFO') || '{}';
        const StorageObj = JSON.parse(StorageStr);
        let deviceId = isIos ? StorageObj.IDFA : StorageObj.UTDID;
        if (!deviceId) {
            deviceId = Math.random()
                .toString()
                .slice(2, 10);
        } else {
            // 字符串转id
            let hash = 0;
            for (let i = 0; i < deviceId.length; i++) {
                let character = deviceId.charCodeAt(i);
                hash = (hash << 5) - hash + character;
                hash = Math.abs(hash & hash); // Convert to 32bit integer
            }
            deviceId = (hash + '').slice(0, 15);
        }
        deviceId = `100${deviceId}`;
        window.localStorage.setItem('deviceUniqueHash', deviceId);
        return deviceId;
    },
    navigateTo(router, routeParams, appArgs = {}) {
        const routerIns = router.resolve(routeParams);
        if (!env.isApp) {
            router.push({ ...routerIns.route });
            return;
        }

        const transformAppArgs = (args = {}) => {
            const argsMap = {
                topbarRemove: 'topbar_remove',
                appOpenPage: 'AppOpenPage',
                selfOpenPage: 'SelfOpenPage',
            };
            return (
                '_t=' +
                new Date().getTime() +
                '&ZZCAppArg=' +
                Object.keys(args)
                    .map(key => {
                        const formatedArg = args[key] ? (argsMap[key] ? argsMap[key] : '') : '';
                        return formatedArg;
                    })
                    .filter(el => !!el)
                    .join(',')
            );
        };
        const defaultAppArgs = {
            topbarRemove: false,
            appOpenPage: true,
            selfOpenPage: false,
        };
        const finalAppArgs = typeof appArgs === 'object' ? Object.assign(defaultAppArgs, appArgs) : appArgs;
        const formattedAppArgs = typeof finalAppArgs === 'object' ? transformAppArgs(appArgs) : finalAppArgs;
        const url = window.location.origin + window.location.pathname + '?' + formattedAppArgs + routerIns.href;
        window.location.href = url;
    },

    navigateBack() {
        if (env.isApp) {
            window.zzc.call('BackToPreviousPage', {
                success: function(response) {
                    console.log(response);
                },
            });
            return;
        }
        window.history.go(-1);
    },

    setNavigationBarTitle(title) {
        window.document.title = title;
        if (env.isApp) {
            window.zzc.call('base_webviewTitle', {
                title,
            });
        }
    },
};
export default util;
